export const environment = {
	production: false,
	enable_service_worker: true,
	apiUrl: 'https://recette.api.cityzen.solutions',
	webUrl: 'https://recette.gestion.cityzen.solutions',
};
